 import './style.css';

export default function Header (){
 return(
   <header className="header">
     <h1 className="title">Catálogo</h1>
    </header>
   )
 }